import { __decorate } from 'tslib';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
let GoogleSheetsDbService = class GoogleSheetsDbService {
    constructor(http) {
        this.http = http;
        this.defaultActiveValues = ['true', '1', 'yes'];
    }
    get(spreadsheetId, worksheetId, attributesMapping) {
        return this.getEntries(spreadsheetId, worksheetId).pipe(map(entries => entries.map(entry => this.getObjectFromEntry(entry, attributesMapping))));
    }
    getActive(spreadsheetId, worksheetId, attributesMapping, isActiveColumnName = 'is_active', activeValues = null) {
        if (activeValues === null) {
            activeValues = this.defaultActiveValues;
        }
        else if (!Array.isArray(activeValues)) {
            activeValues = [activeValues];
        }
        return this.getEntries(spreadsheetId, worksheetId).pipe(map((objects) => objects
            .filter(entry => activeValues.includes(this.getValueFromEntry(entry, isActiveColumnName).toLowerCase()))), map(entries => entries.map(entry => this.getObjectFromEntry(entry, attributesMapping))));
    }
    getSpreadsheetUrl(spreadsheetId, worksheetId) {
        return 'https://spreadsheets.google.com/feeds/list/' + spreadsheetId + '/' + worksheetId + '/public/values?alt=json';
    }
    getEntries(spreadsheetId, worksheetId) {
        const spreadsheetUrl = this.getSpreadsheetUrl(spreadsheetId, worksheetId);
        return this.http.get(spreadsheetUrl).pipe(map(jsonRes => jsonRes.feed.entry), catchError(this.handleError));
    }
    getJsonColumnName(columnName) {
        return columnName
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9-.äöüß]/g, '');
    }
    arrayToObject(array) {
        return array.reduce((acc, cur) => {
            acc[cur] = cur;
            return acc;
        }, {});
    }
    getObjectFromEntry(entry, attributesMapping) {
        if (Array.isArray(attributesMapping)) {
            attributesMapping = this.arrayToObject(attributesMapping);
        }
        return this.getObjectFromEntryObject(entry, attributesMapping);
    }
    getObjectFromEntryObject(entry, attributesMapping, columnNamePrefix = '') {
        const obj = {};
        for (const attr in Object(attributesMapping)) {
            if (attributesMapping.hasOwnProperty(attr) && !['_prefix', '_listField'].includes(attr)) {
                if (typeof attributesMapping[attr] === 'string') {
                    obj[attr] = this.getValueFromEntry(entry, columnNamePrefix + attributesMapping[attr]);
                }
                else if (typeof attributesMapping[attr] === 'object') {
                    let columnName = '';
                    if (attributesMapping[attr].hasOwnProperty('_prefix')) {
                        columnName = attributesMapping[attr]._prefix;
                    }
                    if (attributesMapping[attr]._listField) {
                        obj[attr] = this.getListFromEntry(entry, columnNamePrefix + columnName);
                    }
                    else {
                        obj[attr] = this.getObjectFromEntryObject(entry, attributesMapping[attr], columnNamePrefix + columnName);
                    }
                }
                else {
                    console.log(`Unknown type for ${attr}`);
                }
            }
        }
        return obj;
    }
    getValueFromEntry(entry, attribute) {
        attribute = this.getJsonColumnName(attribute);
        if (entry.hasOwnProperty(`gsx$${attribute}`) && entry[`gsx$${attribute}`].hasOwnProperty('$t')) {
            return entry[`gsx$${attribute}`].$t;
        }
        else {
            return null;
        }
    }
    getListFromEntry(entry, attribute) {
        const list = [];
        let i = 1;
        let curElement = this.getValueFromEntry(entry, `${attribute}${i}`);
        while (curElement) {
            list.push(curElement);
            i++;
            curElement = this.getValueFromEntry(entry, `${attribute}${i}`);
        }
        return list;
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        }
        else {
            console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
        }
        return throwError('Something bad happened; please try again later.');
    }
};
GoogleSheetsDbService.ɵfac = function GoogleSheetsDbService_Factory(t) { return new (t || GoogleSheetsDbService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
GoogleSheetsDbService.ctorParameters = () => [
    { type: HttpClient }
];
GoogleSheetsDbService.ɵprov = ɵɵdefineInjectable({ factory: function GoogleSheetsDbService_Factory() { return new GoogleSheetsDbService(ɵɵinject(HttpClient)); }, token: GoogleSheetsDbService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GoogleSheetsDbService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

/*
 * Public API Surface of ng-google-sheets-db
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GoogleSheetsDbService };

//# sourceMappingURL=ng-google-sheets-db.js.map